import { Box } from "@modernatx-internal/component-library";
import { HeroBanner as PatternHeroBanner } from "@modernatx-internal/website-pattern-library";
import React from "react";

import { useAction } from "@/content-V2/hooks/useAction";
import type { ContentComponentProps, HeroBannerContent } from "@/content-V2/types";
import { useExperience } from "@/context/ExperienceContext";

type PatternHeroBannerProps = React.ComponentProps<typeof PatternHeroBanner>;
type PatternHeroBannerLink = NonNullable<PatternHeroBannerProps["links"]>[number];

export const HeroBanner: React.FC<ContentComponentProps<HeroBannerContent>> = ({
  links,
  ...props
}) => {
  const { handleActionClick } = useAction();
  const { screenshot } = useExperience();
  const rootRef = React.useRef<HTMLDivElement>(null);

  const resolvedLinks = links?.map(({ action, onClick, ...link }) => {
    if (!action) {
      return { ...link, onClick };
    }

    return {
      ...link,
      onClick: (event?: React.MouseEvent) => {
        onClick?.();

        if (event) {
          handleActionClick(event, action).catch(() => {});
        }
      }
    };
  });

  return (
    <Box ref={rootRef} sx={{ width: "100%" }}>
      <PatternHeroBanner
        {...props}
        transition={screenshot ? "none" : props.transition}
        links={resolvedLinks as unknown as PatternHeroBannerLink[] | undefined}
      />
    </Box>
  );
};
